;
define("global_views_confirmation.tpl", function(){});

